import React, { Component } from 'react';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'query-string';

class LayoutPub extends Component {
  constructor(props) {
    super(props);
    const urlParams = qs.parse(this.props.location.search);
    this.state = {
      urlParams,
    };
  }

  render() {
    const { urlParams } = this.state;
    const { pathname } = this.props.location;
    const { user, loading, routes, userBlocked, loggedIn } = this.props;

    // const ipVerify = (urlParams && urlParams.token) && (pathname === '/login');

    const emailChange = (urlParams && urlParams.email_change && urlParams.email_change === 'success') && (pathname === '/login');

    return (
      <div className="page-wrapper">
        <div className="content-wrapper">
          <div className="login-container">
            { userBlocked ? (
              <div className="alert-container vt-banner">
                <div className="alert">
                  Your account has been temporarily blocked for security reasons. Please contact support to discuss.
                </div>
              </div>
            ) : (
              null
            )}
            { emailChange ? (
              <div className="alert-container">
                <div className="alert">
                  Email successfully changed, you have been logged out for security purposes. You can log back in using your new email below.
                </div>
              </div>
            ) : (
              null
            )}
            {/* { ipVerify ? (
              <div className="alert-container vt-banner">
                <div className="alert">
                  Please log in to validate your token.
                </div>
              </div>
            ) : (
              null
            )} */}
            <div className="login-header">
              <a href="/">
                <img alt="Vaultoro Logo" src={ process.env.REACT_APP_CDN + '/assets/images/logo.svg'} />
                <span>Vaultoro</span>
              </a>
            </div>
            {renderRoutes(routes)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  loading: state.user.loading,
});

export default withRouter(connect(mapStateToProps)(LayoutPub));
